<template lang="pug">
div
  h1 Dashboard
    button.icon(@click="fetchDashboards")
      fa(icon="sync-alt")
  p Hi Tobias!
  .boxes
    key-stat-box(title="Players", :value="keyStats.players")
    key-stat-box(title="Games", :value="keyStats.games")
    key-stat-box(title="Steam Players", :value="keyStats.steamPlayers")
    key-stat-box(title="Web Players", :value="keyStats.webPlayers")

  h2 CCU
  .boxes
    key-stat-box(title="Total", :value="keyStats.ccuTotal", :highlight="true")
    key-stat-box(title="Steam", :value="keyStats.ccuSteam")
    key-stat-box(title="Web", :value="keyStats.ccuWeb")
    key-stat-box(title="Web (full)", :value="keyStats.ccuWebFull")
    key-stat-box(title="Demo", :value="keyStats.ccuDemo")
    key-stat-box(title="Beta", :value="keyStats.ccuBeta")

</template>

<script>
import ApiService from "../services/api";
import KeyStatBox from "../components/KeyStatBox";
import { formatBigNumber } from "../utils";

export default {
    components: { KeyStatBox },
    data: () => ({
        keyStats: {
            players: null,
            games: null,
            playing: null,
            events: null,
        },
    }),
    mounted() {
        this.fetchDashboards();
    },

    methods: {
        async fetchDashboards() {
            this.keyStats = {
                players: null,
                games: null,
                webPlayers: null,
                steamPlayers: null,
                ccuTotal: null,
                ccuWeb: null,
                ccuWebFull: null,
                ccuSteam: null,
                ccuBeta: null,
                ccuDemo: null,
            };

            this.keyStats.players = formatBigNumber(
                (await ApiService.query("select count(*)::int from players"))[0].count
            );
            this.keyStats.games = formatBigNumber(
                (await ApiService.query("select count(*)::int from games"))[0].count
            );
            this.keyStats.steamPlayers = formatBigNumber(
                (await ApiService.query("select count(*)::int from players where environment = 'steam'"))[0]
                    .count
            );
            this.keyStats.webPlayers = formatBigNumber(
                (await ApiService.query("select count(*)::int from players where environment = 'prod'"))[0]
                    .count
            );

            const stats = (
                await ApiService.query(`
          select * from player_counts pc order by time desc limit 1
        `)
            )[0];

            this.keyStats.ccuTotal = formatBigNumber(stats.total_count);
            this.keyStats.ccuWeb = formatBigNumber(stats.web_count);
            this.keyStats.ccuSteam = formatBigNumber(stats.steam_count);
            this.keyStats.ccuBeta = formatBigNumber(stats.beta_count);
            this.keyStats.ccuDemo = formatBigNumber(stats.demo_count);
            this.keyStats.ccuWebFull = formatBigNumber(stats.web_full_count);
        },
    },
};
</script>
